import styled from "styled-components";

export const DailySettlementWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  box-sizing: border-box;
  position: relative;
  width: 100%;
  height: 100vh;
  padding: 50px 50px 0 30px;

  .no-data {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Pretendard;
    font-weight: 700;
    font-size: 22px;
    text-align: center;
    color: #969696;
  }
`;

export const DailySettlementPopupItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  > .name {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 15px;
  }
`;

export const DailySettlementInputItem = styled.div<{
  width?: string;
  height?: string;
}>`
  width: ${(p) => (p.width ? p.width : "154px")};
  height: ${(p) => (p.height ? p.height : "34px")};
  border-radius: 9.78px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 15px;
  color: #121212;
  position: relative;

  > input {
    border-radius: 9.78px;
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    font-family: Pretendard;
    font-weight: 500;
    font-size: 15px;
    color: #121212;
    text-align: center;
  }

  > span {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const DailySettlementButtonWrapper = styled.div<{ width?: string }>`
  width: ${(p) => (p.width ? p.width : "100%")};
  height: 48px;
  display: flex;
  gap: 8px;

  > .button {
    flex: 1;
    height: 48px;
    border-radius: 8px;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 15px;
    line-height: 48px;
    text-align: center;
    background: #fff;
    color: #6436e7;
    cursor: pointer;

    &.purple {
      color: #fff;
      background: #6436e7;
    }
  }
`;

export const DailySettlementSectionWrapper = styled.div`
  display: flex;
  gap: 32px;
  padding-bottom: 40px;
`;

export const DailySettlementContentWrapper = styled.div<{
  width: string;
  height?: string;
  padding?: string;
}>`
  height: ${(p) => (p.height ? p.height : "804px")};
  width: ${(p) => p.width};
  box-sizing: border-box;
  border-radius: 18.53px;
  background: #fffffff0;
  border: 0.93px solid #bfbfbf;
  box-shadow: 0px 3.71px 3.71px 0px #00000040;
  padding: ${(p) => (p.padding ? p.padding : " 37px 30px 0")};

  > .pagination {
    padding: 0 0 50px;
  }
`;

export const DailySettlementSortArrowWrapper = styled.div`
  display: flex;
  flex-direction: column;

  > img {
    width: 8px;
    height: 8px;
    opacity: 0.3;
    transition: opacity 0.2s;

    &.active {
      opacity: 1;
    }

    &.arrow-up {
      transform: rotate(180deg);
    }

    &.arrow-down {
      transform: rotate(0deg);
    }
  }
`;

export const DailySettlementMainBox = styled.div<{
  isPurple?: boolean;
  width?: string;
  height?: string;
}>`
  width: ${(p) => (p.width ? p.width : "295px")};
  height: ${(p) => (p.height ? p.height : "122px")};
  border-radius: 18.53px;
  padding: 24px 20px;
  box-sizing: border-box;
  color: ${(p) => (p.isPurple ? "#fff" : "#121212")};
  background: ${(p) => (p.isPurple ? "#7F25FB" : "#ECF0F3")};
  font-family: Pretendard;
  position: relative;

  > .name {
    font-weight: 700;
    font-size: 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    > img {
      cursor: pointer;
    }
  }

  > .info {
    font-weight: 700;
    font-size: 18px;
    font-weight: 500;
  }

  > .value {
    text-align: right;
    margin-top: 10px;
    font-weight: 700;
    font-size: 36px;
  }

  > .input {
    margin-top: 10px;

    > input {
      font-weight: 700;
      font-size: 36px;
    }
  }
`;

export const DailySettlementRevenueMainTableWrapper = styled.div<{
  isPadding?: boolean;
}>`
  padding-bottom: ${(p) => (p.isPadding ? "69px" : "")};
  color: #121212;
  text-align: right;
  font-family: Pretendard;
  font-weight: 600;
  font-size: 15px;
`;

export const DailySettlementRevenueMainTableHeader = styled.div<{
  width?: string;
}>`
  display: flex;

  > .header {
    width: 121px;
    box-sizing: border-box;
  }

  > .item {
    background: #ecf0f3;
    width: ${(p) => (p.width ? p.width : "158px")};
    height: 30px;
    border: 1px solid #ecf0f3;
    border-right: 1px solid #d9d9d9;
    line-height: 30px;
    text-align: center;
    box-sizing: border-box;
  }
`;

export const DailySettlementRevenueMainTableBody = styled.div`
  display: flex;
`;

export const DailySettlementRevenueMainTableItem = styled.div<{
  width?: string;
}>`
  display: flex;
  flex-direction: column;

  > .header {
    width: 121px;
    height: 30px;
    line-height: 30px;
    box-sizing: border-box;
    text-align: center;
  }

  > .item {
    background: #fff;
    width: ${(p) => (p.width ? p.width : "158px")};
    height: 30px;
    border: 1px solid #ecf0f3;
    border-right: 1px solid #d9d9d9;
    line-height: 30px;
    color: #121212;
    padding: 0 10px;
    box-sizing: border-box;

    &.center {
      text-align: center;
    }
  }
`;

export const DailySettlementRecordTableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 585px;
  margin-top: 30px;

  .item {
    flex: 1;
  }

  .time {
    width: 100px;
    flex: none;
  }

  .type {
    width: 42px;
    flex: none;
  }

  .memo {
    width: 90px;
    flex: none;
  }

  .amount {
    width: 66px;
    flex: none;
  }
`;

export const DailySettlementRecordTableItem = styled.div`
  display: flex;
  gap: 10px;
  background: #ecf0f3;
  height: 40px;
  border-radius: 10.64px;
  padding: 0 15px;
  width: 472px;
  box-sizing: border-box;
  align-items: center;

  > .item {
    font-family: Pretendard;
    font-weight: 500;
    font-size: 10px;
    text-align: center;
    color: #121212;
  }

  .amount {
    width: 66px;
  }

  .button {
    width: 50px;
    height: 24px;
    border-radius: 6px;
    background: #bebebe;
    color: #fff;
    line-height: 24px;

    &.red {
      background: #d91818;
    }
  }
`;

export const DailySettlementRecordTableHeader = styled.div`
  display: flex;
  gap: 10px;
  padding: 12px 15px;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  border-top: 1.53px solid #d9d9d9;

  > .item {
    font-family: Pretendard;
    font-weight: 500;
    font-size: 12px;
    text-align: center;
    color: #121212;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    cursor: pointer;
  }
`;
